import _ from 'lodash';
import { AxiosPromise } from 'axios';
import { Response } from 'types/apiResponse';
import { RequestOptions } from './getRequestOptions';


/**
 * Given a request function, repeats request until all paged data has been obtained
 * @param {*} requestFn the function that makes the HTTP request
 * @param {*} options options passed to the request function
 */

const requestAllPagedData = (
  requestFn: (options: RequestOptions) => AxiosPromise,
  options: RequestOptions = {},
): any => (
  requestFn(options).then((response: Response): PromiseConstructor => {
    // get page data
    const totalPages: number = _.get(response, ['data', 'page', 'totalPages']);
    const pagesRemaining = (totalPages - 1);
    // init an array to hold remaining requests
    const batchedRequests = [];

    // for each page remaining, create a new request
    for (let nextPage = 1; nextPage <= pagesRemaining; nextPage += 1) {
      batchedRequests.push(requestFn({
        ...options,
        params: {
          ...options.params,
          page: nextPage,
        },
      }));
    }
    // return an array containing all responses
    // @ts-ignore
    return Promise.all(batchedRequests).then((nextResponses): Response => [response, ...nextResponses]);
  })
  // make the first request
);

export default requestAllPagedData;
